import { NFeEntradaFormacaoPrecosFormulaStruct } from '@shared/services/structs/orquestrador-compras/nfe-entrada-formacao-precos-formula.struct';
import { NFeEntradaFormacaoPrecosMemoriaStruct } from '@shared/services/structs/orquestrador-compras/nfe-entrada-formacao-precos-memoria.struct';
import { NFeEntradaFormacaoPrecosVariavelStruct } from '@shared/services/structs/orquestrador-compras/nfe-entrada-formacao-precos-variavel.struct';

export class FormacaoPrecosMemoriaCalculoDialogData {
  descricaoItem = '';
  /** Fórmula efetiva do preço de custo, como a empresa a configurou. */
  formula: NFeEntradaFormacaoPrecosFormulaStruct | null = null;
  variaveis: NFeEntradaFormacaoPrecosVariavelStruct[] = [];
  memoriaPrecoCusto: NFeEntradaFormacaoPrecosMemoriaStruct | null = null;
  memoriaImpostosRecuperaveis: NFeEntradaFormacaoPrecosMemoriaStruct | null = null;
}
